import React, { useCallback } from "react";
import classNames from "classnames";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const IndentifyLayout = () => {
  const { t } = useTranslation();
  const cardList = [
    [
      {
        icon: "identify-lark.png",
        title: t("identify.identifyLayout.item1.title"),
        subtitle: t("identify.identifyLayout.item1.subtitle"),
      },
      {
        icon: "identify-ad.png",
        title: t("identify.identifyLayout.item2.title"),
        subtitle: t("identify.identifyLayout.item2.subtitle"),
      },
      {
        icon: "identify-wecom.png",
        title: t("identify.identifyLayout.item3.title"),
        subtitle: t("identify.identifyLayout.item3.subtitle"),
      },
      {
        icon: "identify-dingding.png",
        title: t("identify.identifyLayout.item4.title"),
        subtitle: t("identify.identifyLayout.item4.subtitle"),
      },
    ],
    [
      {
        icon: "identify-ldap.png",
        title: t("identify.identifyLayout.item5.title"),
        subtitle: t("identify.identifyLayout.item5.subtitle"),
      },
      {
        icon: "identify-ldap-department.png",
        title: t("identify.identifyLayout.item6.title"),
        subtitle: t("identify.identifyLayout.item6.subtitle"),
      },
      {
        icon: "identify-moka.png",
        title: t("identify.identifyLayout.item7.title"),
        subtitle: t("identify.identifyLayout.item7.subtitle"),
      },
    ],
  ];
  return (
    <>
      <div className="indetity-layout">
        <div className="basic-column">
          <div className="indentify-title">
            {t("identify.identifyLayout.title")}
          </div>
          <div className="indentify-subtitle">
            {t("identify.identifyLayout.subtitle1")}
          </div>
          <div className="indentify-subtitle" style={{ marginBottom: 60 }}>
            {t("identify.identifyLayout.subtitle2")}
          </div>
          <div className="indetity-scroll-card-warp">
            <div className="scroll-mask"></div>
            {cardList.map((lists) => {
              return (
                <div className="scroll-container">
                  {[...lists, ...lists].map((item, index) => {
                    return (
                      <div key={index} className="layout-item">
                        <div className="item-icon">
                          <img
                            src={`https://files.authing.co/authing-website/${item.icon}`}
                            alt="authing"
                          />
                        </div>
                        <div className="item-title">{item.title}</div>
                        <div className="item-descript">{item.subtitle}</div>
                      </div>
                    );
                  })}
                  {[...lists, ...lists].map((item, index) => {
                    return (
                      <div key={index} className="layout-item">
                        <div className="item-icon">
                          <img
                            src={`https://files.authing.co/authing-website/${item.icon}`}
                            alt="authing"
                          />
                        </div>
                        <div className="item-title">{item.title}</div>
                        <div className="item-descript">{item.subtitle}</div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
